import { createSelector } from 'reselect';
import TableDefinitions from '../../../../../common/TableDefinitions';
import EdiRfidAuditRequestListColumns from '../../containers/EdiRfidAuditRequestListColumns';

export const getIsLoading = (state) => state.listing.EDI_RFID_AUDIT_REQUESTS_LIST_PAGE.isLoading;
export const getCheckedRows = (state) => state.listing.EDI_RFID_AUDIT_REQUESTS_LIST_PAGE.selectedRows;
export const getData = TableDefinitions.EDI_RFID_AUDIT_REQUESTS_LIST_PAGE.getDataFunction();
export const getColumns = createSelector(
  getData,
  EdiRfidAuditRequestListColumns,
);
